<template v-slot:content>
  <div>
    <group-card-row title="Income">
      <template v-slot:content>
        <div class="md-layout-item md-size-100">
          <div class="property-list">
            <property-view
              name="Employment"
              right
              width="300px"
              name_width="150px"
            >
              {{ employmentIncome | currency }} / m
            </property-view>
            <br />
            <property-view name="Spouse" right width="300px" name_width="150px">
              {{ spouseIncome | currency }} / m
            </property-view>
            <br />
            <property-view name="Assets" right width="300px" name_width="150px">
              {{ assetsIncome | currency }} / m
            </property-view>
            <br />
            <property-view name="Other" right width="300px" name_width="150px">
              {{ otherIncome | currency }} / m
            </property-view>
          </div>
        </div>
      </template>
      <template v-slot:validation></template>
    </group-card-row>

    <group-card-row title="Expenses">
      <template v-slot:content>
        <div class="md-layout">
          <div class="md-layout-item md-size-33 md-large-size-33 md-medium-size-33 md-small-size-33 md-xsmall-size-33">
            <div class="property-list">
              <property-view name="Living" right width="300px" name_width="150px">
                {{ expense | currency }} / m
              </property-view>
              <br />
              <property-view
                name="Asset & Liabilities"
                right
                width="300px"
                name_width="150px"
              >
                {{ liabilityExpense | currency }} / m
              </property-view>
              <br />
              <property-view name="Rent" right width="300px" name_width="150px">
                {{ rentExpense | currency }} / m
              </property-view>
            </div>
          </div>
          <div 
            class="md-layout-item md-size-66 md-large-size-66 md-medium-size-66 md-small-size-66 md-xsmall-size-66"
            v-if="showLivingExpenseWarning">
            <div class="md-layout">
              <p class="low_expenses_declare">
                Declared living expenses are below expected benchmark, confirm all household expenses have been declared before processing
                and provide explanation for below average spending.
              </p>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-20 md-large-size-20 md-medium-size-20 md-small-size-20 md-xsmall-size-20">
                <md-field>
                  <label>Tag</label>
                  <md-input v-model="comment.tag" disabled></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-60 md-large-size-60 md-medium-size-60 md-small-size-60 md-xsmall-size-60">
                <md-field>
                  <label>Comments</label>
                  <md-textarea v-model="comment.content" md-autogrow></md-textarea>
                </md-field>
              </div>
              <div class="md-layout-item md-size-10 md-large-size-0 md-medium-size-10 md-small-size-10 md-xsmall-size-10">
                <md-button class="md-primary" @click="saveLowExpensesComment">Process</md-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:validation></template>
    </group-card-row>

    <group-card-row title="Capacity">
      <template v-slot:content>
        <div class="md-layout-item md-size-100">
          <div class="property-list">
            <property-view
              name="Total Income"
              right
              width="300px"
              name_width="150px"
            >
              {{ validation.capacity.income | currency }} / m
            </property-view>
            <br />
            <property-view
              name="Total Expenses"
              right
              width="300px"
              name_width="150px"
            >
              {{ validation.capacity.expense | currency }} / m
            </property-view>
            <br />
            <property-view
              name="Uncommitted Income"
              right
              width="300px"
              name_width="150px"
            >
              {{ validation.capacity.uncommitted_income | currency }} / m
            </property-view>
          </div>
        </div>
      </template>
      <template v-slot:validation>
        <p v-for="note of validation.capacity.notes" :key="note.id">
          <note-view status="bad">{{ note }}</note-view>
        </p>
      </template>
    </group-card-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import ValidatedInputs from "@/components/ValidatedInput";
import ListItemCard from "@/components/Cards/ListItemCard.vue";
import { GroupCard } from "@/components";
import { GroupCardRow } from "@/components";
import { applicationValidation, moneyThreeExpense } from "@/components/utils/validation";
import PropertyView from "../ApplicationSummary/PropertyView";
import { NoteView } from "@/components";
import AlertDialog from "../Dialogs/AlertDialog";

export default {
  components: {
    ...ValidatedInputs,
    ListItemCard,
    GroupCard,
    GroupCardRow,
    PropertyView,
    NoteView,
    AlertDialog,
  },
  data() {
    return {
      comment: {
        tag: null,
        content: "",
        completed: false,
        name: {
          first_name: "",
          last_name: "",
        },
      },
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    application: {
      type: Object,
      required: true,
    },
  },
  watch: {
    "asset.type"() {
      this.matchAssetsHasToType();
    },
    "asset.has_trade_in"(has_trade_in) {
      if (has_trade_in) {
        this.$emit("set-as-trade-in");
      }
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters(["user"]),
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() {
        return this.value;
      },
      set(applicant) {
        this.$emit("input", applicant);
      },
    },
    validation() {
      return applicationValidation(this.application);
    },

    employmentIncome() {
      const obj = this.validation.employments.incomeArr.find(
        (income) =>
          income.applicantId == this.applicant.id ||
          income.applicantId ==
            this.application.applicants.indexOf(this.applicant)
      );
      return obj.employment;
    },

    spouseIncome() {
      const obj = this.validation.employments.incomeArr.find(
        (income) =>
          income.applicantId == this.applicant.id ||
          income.applicantId ==
            this.application.applicants.indexOf(this.applicant)
      );
      return obj.spouse;
    },

    assetsIncome() {
      const obj = this.validation.assets.assetsIncome.find(
        (income) =>
          income.applicantId == this.applicant.id ||
          income.applicantId ==
            this.application.applicants.indexOf(this.applicant)
      );
      return obj?.assetIncome;
    },

    otherIncome() {
      const obj = this.validation.otherIncomes.incomes.find(
        (income) =>
          income.applicantId == this.applicant.id ||
          income.applicantId ==
            this.application.applicants.indexOf(this.applicant)
      );
      return obj.otherIncomeValue;
    },

    expense() {
      const obj = this.validation.expenses.perApplicant.find(
        (expense) =>
          expense.applicantId == this.applicant.id ||
          expense.applicantId ==
            this.application.applicants.indexOf(this.applicant)
      );
      return obj.expense;
    },

    liabilityExpense() {
      const obj = this.validation.assets.assetsIncome.find(
        (income) =>
          income.applicantId == this.applicant.id ||
          income.applicantId ==
            this.application.applicants.indexOf(this.applicant)
      );
      return obj?.liabilityExpense;
    },

    rentExpense() {
      const obj = this.validation.addresses.perApplicantRentExpense.find(
        (expense) =>
          expense.applicantId == this.applicant.id ||
          expense.applicantId ==
            this.application.applicants.indexOf(this.applicant)
      );
      return obj.expense;
    },

    showLivingExpenseWarning() {
      const hemExpenses = this.validation.living_expenses;
      // if expense less than living expense benchmark, show warning
      return this.expense < hemExpenses;
    }
  },

  mounted() {
    this.retrieveLowExpensesComment();
  },

  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    retrieveLowExpensesComment() {
      const comment = this.application.loan.comments.find(
        (comment) => comment.tag == "Low Expenses"
      );
      if (comment) {
        this.comment = comment;;
      } else {
        this.comment = this.newLowExpensesComment();
      }
    },

    newLowExpensesComment() {
      return {
        tag: "Low Expenses",
        content: "",
        completed: false,
        name: {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
        },
      };
    },

    async saveLowExpensesComment() {
      // check is this.comment.content is empty or null
      if (this.comment.content) {
        // check if this.comment is already in the comments array
        const comment = this.application.loan.comments.find(
          (comment) => comment.tag == "Low Expenses"
        );
        if (comment) {
          // if comment is already in the comments array, update the comment
          comment.content = this.comment.content;
        } else {
          // if comment is not in the comments array, add the comment
          this.application.loan.comments.push(this.comment);
        }
        try {
          await this.$store.dispatch("save_application", this.application);
        } catch {
          this.$modal.show(AlterDialog, {
            title: "Error",
            content: "Failed to save comment",
          });
        }
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'capacity_rules',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.divide-right {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.low_expenses_declare {
  font-size: 16px;
  font-weight: bold;
  margin-left: 12px;
  margin-bottom: 12px;
}
</style>
